import $examApi from "@/api/examApi.js";
export const hybrid = {
  // 该混入是适用于在线练习和练习监控的方法共用
  data() {
    return {
      editTimeDialog: {
        title: "考试时间设置",
        width: 800,
        height: 150,
        visible: false
      },
      labelPosition: "right",
      pageIndex: 1, // 起始页
      eachPageNum: 10, // 一页多少条数据
      total: 100,
      pagesizesarr: [5, 10, 20, 50, 100]
    };
  },
  methods: {
    isNumber: function(val) {
      let reg = /^[0-9]*$/;
      if (!reg.test(val)) {
        return false;
      }
      return true;
    },
    // 封装方法
    commonParms: function(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    translationtime: function() {
      let defaultstarttime = new Date(
        new Date(this.lastBeginTime).getTime() + 1000 * 60 * 30
      );
      let defaultendtime = new Date(
        new Date(this.lastBeginTime).getTime() + 1000 * 60 * 150
      );
      this.timeSelect[0] = this.$moment(defaultstarttime).format(
        "YYYY-MM-DD HH:mm"
      );
      this.timeSelect[1] = this.$moment(defaultendtime).format(
        "YYYY-MM-DD HH:mm"
      );
    },
    timechange: function() {
      //防止清空之后选项成对象
      if (!this.timeSelect) {
        this.timeSelect = [];
      }
      let lastTime = this.$moment(this.lastBeginTime).format(
        "YYYY-MM-DD HH:mm"
      );
      let nowdifftime = this.$moment(this.timeSelect[0]).diff(
        lastTime,
        "minutes"
      );
      if (nowdifftime < 0) {
        this.$message.warning(
          `考试开始日期时间应大于上一次考试日期时间(${lastTime})`
        );
        this.translationtime();
        return;
      }
    },
    editConfirm: function() {
      if (this.timeSelect.length == 0) {
        this.$message.warning("考试时间不能为空！");
        return;
      }
      if (!this.timeValue) {
        this.$message.warning("答题时长不能为空！");
        return;
      }
      if (!this.isNumber(this.timeValue)) {
        this.$message.warning("请输入纯数字类型！");
        return;
      }
      if (this.timeValue < 10) {
        this.$message.warning("答题时长不能低于10分钟！");
        return;
      }
      let parms = {};
      parms = this.commonParms(parms);
      parms.examID = this.examId;
      parms.examBeginTime = this.$moment(this.timeSelect[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      parms.examEndTime = this.$moment(this.timeSelect[1]).format(
        "YYYY-MM-DD HH:mm"
      );
      parms.timeValue = this.timeValue;
      $examApi
        .updateExamTime(parms)
        .then(res => {
          let result = res.data;
          if (result.Status === 200) {
            this.$message.success("修改考试信息成功！");
            this.editTimeDialog.visible = false;
            this.getDatalist();
          } else {
            this.$message.error("修改考试信息失败！");
          }
        })
        .catch(err => {
          this.$message.error("修改考试信息失败！");
        });
    },
    editClose: function() {
      this.editTimeDialog.visible = false;
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      } else if (rowIndex % 2 === 0) {
        return "success-row";
      }
      return "";
    },
    // 重置
    resetFun(form, newform) {
      this.loading = true;
      Object.keys(form).forEach(key => {
        form[key] = "";
      });
      Object.keys(newform).forEach(key => {
        newform[key] = "";
      });
      this.getDatalist();
    },
  }
};
